import UpdatePhoneNumber from '@/views/UpdatePhoneNumber/index.vue'

const UpdatePhoneNumberRouter = {
  path: '/update-phone-number',
  name: 'UpdatePhoneNumber',
  component: UpdatePhoneNumber,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default UpdatePhoneNumberRouter
